import { createContext, useContext } from 'react';

import { IInventorySmartFloorPayloadUI } from '~/src/dash/apiV2/smartFloors/crud';
import { IPermissionCheck } from '~/src/dash/utils/permission_service';
import { ISmartFloorsListViewConfig } from '~/src/dash/views/channels/SmartFloors/SmartFloorsListView/config';
import { ISmartFloorsLiveAdaptiveConfig } from '~/src/dash/views/channels/SmartFloors/SmartFloorsLiveAdaptiveView/config';
import { ISmartFloorsLiveConfig } from '~/src/dash/views/channels/SmartFloors/SmartFloorsLiveView/config';

interface ISmartFloorsListContext {
  handlers: {
    handleSelectBidderOnChart: (bidderID: number, currVal: boolean) => void;
    handleUpdateBidFloorForSmartFloor: (bidderID: number, newValue: number) => void;
  };
  readAuthorization: IPermissionCheck;
  SmartFloors: {
    data: IInventorySmartFloorPayloadUI[];
    cfg: ISmartFloorsListViewConfig;
    selectedBidderIDForSmartFloorsChart: number;
  };
  shouldAllowSortingTable: boolean;
  writeAuthorization: IPermissionCheck;
}

interface ISmartFloorsLiveContext {
  SmartFloorsStore: {
    Live: ISmartFloorsLiveConfig;
    selectedSmartFloor: IInventorySmartFloorPayloadUI;
    selectedBidderName: string;
    selectedBidderID: number;
  };
}

interface ISmartFloorsLiveAdaptiveContext {
  liveConfig: ISmartFloorsLiveAdaptiveConfig;
  selectedBidder: { ID: number; Name: string };
  selectedSmartFloor: IInventorySmartFloorPayloadUI;
}

export const SmartFloorsListContext = createContext({} as ISmartFloorsListContext);
export const useSmartFloorsListStore = (): ISmartFloorsListContext =>
  useContext(SmartFloorsListContext);

export const SmartFloorsLiveContext = createContext({} as ISmartFloorsLiveContext);
export const useSmartFloorsLiveStore = (): ISmartFloorsLiveContext =>
  useContext(SmartFloorsLiveContext);

export const SmartFloorsLiveAdaptiveContext = createContext({} as ISmartFloorsLiveAdaptiveContext);
export const useSmartFloorsLiveAdaptiveStore = (): ISmartFloorsLiveAdaptiveContext =>
  useContext(SmartFloorsLiveAdaptiveContext);
